import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Objects, Parts, Types} from "components/index";
import GoogleMapReact from "google-map-react";
import API from "@beardeddevops/react.api";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Select from "react-select";
import Person from "@material-ui/icons/Person"
import {Circle} from '@react-google-maps/api'
import {Polygon} from '@react-google-maps/api'
import {Button} from "reactstrap";
import moment from "moment";
import {isEmptyObject} from "jquery";
import Paper from "@material-ui/core/Paper";
import {Slider, FormHelperText} from "@material-ui/core";
import UserRoles from "../../constants/UserRoles";
import {getGoogleMapBootstrapURLKeys} from "../../constants/GoogleMaps";
import {isEmpty} from "lodash";
import Home from "@material-ui/icons/Home";
import {confirmAlert} from "react-confirm-alert";
import {DEFAULT_FEEDBACK_INTERNAL_NAME} from "../../constants/FeedbackZoneDefaults";
import FeedbackLocationSelect, {
	loadFeedbackLocations,
	findFeedbackLocationByPkey,
	nextInternalNameForLocation,
	FEEDBACK_FORM_HELPER_TEXT_STYLE,
} from "../Parts/FeedbackLocationSelect";
export default class RegionFeedback extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Regions_Feedback._name);

		this.state.coords = [];
		this.state.feedbackZones = [];
		this.state.key = 0;
		this.state.addZone = false;
		this.state.regions = [];
		this.state.selectedRegion = {
			pkey: 1,
			name: "Phoenix (602, 480, 623)",
			latitude: 33.4484000,
			longitude: -112.0740000,
		};
		this.state.defaultCenter = {
			lat: 33.4484000,
			lng: -112.0740000
		}
		this.state.feedbackLocations = [];
	}

	async componentDidMount() {
		this.setState({loading: true, items: []});
		const params = new URLSearchParams(this.props.history?.location?.search || '');
		const regionParam = params.get('region');
		const zoneParam = params.get('zone');

		await this.getRegions();
		await this.fetchFeedbackLocations();
		if (regionParam) {
			const region = this.state.regions.find((item) => item.pkey === parseInt(regionParam, 10));
			if (region) {
				this.state.selectedRegion = region;
				this.setState({selectedRegion: region});
			}
		}

		const zones = await this.getZones(!regionParam);
		if (zoneParam) {
			this.focusZoneByPkey(parseInt(zoneParam, 10), zones);
		}
	}

	focusZoneByPkey = (zonePkey, zones = null) => {
		const zone = (zones || this.state.feedbackZones || []).find((item) => item.pkey === zonePkey);
		if (!zone) {
			return;
		}
		this.setState({focusZone: zone}, () => this.panToZone(zone));
	}

	panToZone = (zone) => {
		if (!this.state.map || !this.state.maps || !zone?.coords) {
			return;
		}
		try {
			const coords = JSON.parse(zone.coords);
			if (!Array.isArray(coords) || coords.length === 0) {
				return;
			}
			const lat = coords.reduce((sum, point) => sum + point.lat, 0) / coords.length;
			const lng = coords.reduce((sum, point) => sum + point.lng, 0) / coords.length;
			this.state.map.panTo(new this.state.maps.LatLng(lat, lng));
			this.state.map.setZoom(11);
		} catch (e) {
		}
	}

	prepareFeedbackZoneFields = () => {
		const link = (this.state.link || '').trim();
		const rankingRaw = this.state.ranking;
		const ranking = rankingRaw === null || rankingRaw === undefined || `${rankingRaw}`.trim() === ''
			? null
			: parseInt(rankingRaw, 10);

		return {
			link,
			feedback_location: this.state.feedback_location || null,
			name: (this.state.name || '').trim() || DEFAULT_FEEDBACK_INTERNAL_NAME,
			pretty_name: (this.state.pretty_name || '').trim(),
			ranking: Number.isNaN(ranking) ? null : ranking,
		};
	};

	validateFeedbackZoneSave = (isNewZone, isRedraw) => {
		const fields = this.prepareFeedbackZoneFields();
		const {pretty_name, ranking} = fields;

		if ((isNewZone || isRedraw) && this.state.coords.length < 3) {
			alert('Draw at least 3 points on the map to define the feedback zone.');
			return false;
		}

		let prettyNameError = '';
		let linkError = '';
		let rankingError = '';

		if (!pretty_name) {
			prettyNameError = 'Required';
		}

		if (!fields.link) {
			linkError = 'Required';
		}

		if (!isNewZone && (ranking === null || ranking === undefined || `${ranking}`.trim() === '')) {
			rankingError = 'Required';
		}

		this.setState({
			pretty_name_error: prettyNameError,
			link_error: linkError,
			ranking_error: rankingError,
		});

		return !prettyNameError && !linkError && !rankingError;
	}

	fetchFeedbackLocations = async () => {
		try {
			const feedbackLocations = await loadFeedbackLocations();
			this.setState({feedbackLocations});
		} catch (error) {
		}
	}

	handleFeedbackLocationSelect = (location) => {
		if (!location) {
			this.setState({feedback_location: null});
			return;
		}

		const previousLocation = findFeedbackLocationByPkey(
			this.state.feedbackLocations,
			this.state.feedback_location
		);
		const name = nextInternalNameForLocation(this.state.name, previousLocation, location);

		this.setState({
			feedback_location: location.pkey,
			name,
		});
	}

	handleLinkFieldUpdate = (property, value) => {
		this.handleTextFieldPropertyUpdate(property, value);
	}

	clearFeedbackZoneForm = () => ({
		coords: [],
		addZone: false,
		re_zone: null,
		zoneSelected: false,
		zoneId: null,
		selectedCoords: [],
		selectedZone: null,
		link: null,
		feedback_location: null,
		name: null,
		pretty_name: null,
		ranking: null,
		link_error: '',
		pretty_name_error: '',
		ranking_error: '',
	});

	

	apiIsLoaded = (map, maps) => {
		this.setState({map, maps}, () => {
			if (this.state.focusZone) {
				this.panToZone(this.state.focusZone);
			}
		});
	};

	getZones = async (firstload = false) => {
		this.setState({feedbackZones: []})
		if (this.state.map) {
			const latLng = new this.state.maps.LatLng(this.state.selectedRegion.latitude, this.state.selectedRegion.longitude); // Makes a latlng
			this.state.map.panTo(latLng);
			this.state.map.setZoom(9)
		}
		//get zones here
		let zoneModel = new API.BuildClass(Types.Regions_Feedback._name, API.RequestType.READ_ALL);
		zoneModel.filter = {
			'region': this.state.selectedRegion.pkey,
			'admin': true
		}
		if(firstload){
			zoneModel.parent = 1;
		} else {
			zoneModel.parent = this.state.selectedRegion.pkey;
		}
		zoneModel = await zoneModel.submit(null, 'GET_ALL');
		const items = zoneModel.items ?? [];
		this.setState({feedbackZones: items});

		return items;
	}

	getRegions = async () => {
		let model = new API.BuildClass(Types.Regions._name, API.RequestType.READ_ALL);
		this.read = 'GET_ALL';
		model.limit = 5000;
		try {
			this.regions = await model.submit(null, this.read);
			this.regions = Object.keys(this.regions).map((key) => this.regions[key]);
			this.regions = this.regions[3];
			this.regions = this.regions.sort(function (a, b) {
				return a.name.localeCompare(b.name)
			})
			this.regions = this.regions.filter((region) => {
				return region.latitude > 0 || region.latitude < 0
			})
			this.setState({
				regions: this.regions,
				selectedRegion: this.regions.find((item) => item.pkey === this.state.selectedRegion.pkey)
			});
		} catch (error) {
		}
	}
	render() {
		let zoom = 9;
		let extras = {};

		let {properties} = this.model

		let object = this.state;

		return (
			<Card>
				<CardContent>
					<div>
						<div className={"table-bar"}>
							<div className={'row'}>

								<div className={'col-3'} style={{display: 'flex', flexDirection: 'column', zIndex: 999}}>
									<Select
										key={this.state.regions}
										placeholder={"Region Select"}
										value={{value: this.state.selectedRegion.pkey, label: this.state.selectedRegion.name}}
										onChange={async (value) => {
											//this.setState({selectedRegion: this.state.regions.find((region) => region.pkey === value.value)})
											this.state.selectedRegion = this.state.regions.find((region) => region.pkey === value.value)
											await this.getZones()
										}}
										options={this.state.regions?.map(region => {
											return (
												{value: region.pkey, label: region.name}
											)
										})}
										styles={{
											singleValue: (provided, state) => ({
												...provided,
												display: 'flex',
												alignItems: 'center'
											}),
											option: (provided, state) => ({
												...provided,
												display: 'flex',
												alignItems: 'center'
											})
										}}
									/>
								</div>
								{this.props.showButtons && <div className={'col-2 text-right'}>
									<Button color={'primary'} size={'sm'} onClick={async () => {
										if (!this.state.addZone && !this.state.zoneSelected) {
											this.setState({addZone: true, zoneSelected: null, zoneId: null, link: null, feedback_location: null, name: null, pretty_name: null, ranking: null})
										} else {
											const isRedraw = !!this.state.re_zone;
											const isNewZone = !this.state.re_zone && !this.state.zoneSelected;
											if (!this.validateFeedbackZoneSave(isNewZone, isRedraw)) {
												return;
											}
											const fields = this.prepareFeedbackZoneFields();
											if (this.state.re_zone || this.state.zoneSelected) {
												let zoneModel = new API.BuildClass(Types.Regions_Feedback._name, API.RequestType.READ_ALL);
												if (this.state.re_zone){
													zoneModel.object.coords = JSON.stringify(object.coords);
												} else {
													delete zoneModel.object.coords;
												}
												zoneModel.pkey = this.state.zoneId ?? this.state.re_zone;
												zoneModel.object.pkey = this.state.zoneId ?? this.state.re_zone;
												zoneModel.parent = this.state.selectedRegion.pkey;
												zoneModel.object.region = this.state.selectedRegion.pkey;
												zoneModel.object.link = fields.link;
												zoneModel.object.feedback_location = fields.feedback_location;
												zoneModel.object.name = fields.name;
												zoneModel.object.pretty_name = fields.pretty_name;
												zoneModel.object.ranking = fields.ranking;
												await zoneModel.submit(null, 'POST');
											} else {
												let zoneModel = new API.BuildClass(Types.Regions_Feedback._name, API.RequestType.READ_ALL);
												zoneModel.parent = this.state.selectedRegion.pkey;
												zoneModel.object.coords = JSON.stringify(object.coords);
												zoneModel.object.region = this.state.selectedRegion.pkey;
												zoneModel.object.link = fields.link;
												zoneModel.object.feedback_location = fields.feedback_location;
												zoneModel.object.name = fields.name;
												zoneModel.object.pretty_name = fields.pretty_name;
												zoneModel.object.ranking = fields.ranking;
												await zoneModel.submit(null, 'PUT');
											}
											await this.getZones();
											this.setState(this.clearFeedbackZoneForm());
										}
									}}>{this.state.addZone || this.state.zoneSelected ? 'Save Feedback Zone' : 'Add Feedback Zone'}</Button>
								</div>}

								{this.props.showButtons && <div className={'col-1 text-right'}>
									<Button color={'danger'} disabled={!this.state.zoneSelected} size={'sm'} onClick={async () => {
										let zoneModel = new API.BuildClass(Types.Regions_Feedback._name, API.RequestType.DELETE);
										zoneModel.parent = this.state.selectedRegion.pkey;
										zoneModel.pkey = this.state.zoneId;
										zoneModel.object.pkey = this.state.zoneId;
										await zoneModel.submit(null, 'DELETE');
										await this.getZones();
										this.setState({zoneSelected: false, re_zone: null, coords: [], addZone: false, selectedCoords: [], link: null, feedback_location: null, name: null, pretty_name: null, ranking: null, zoneId: null})
									}}>Delete Zone</Button>
								</div>}

								{this.props.showButtons && <div className={'col-1 text-right'}>
									<Button color={'warning'} disabled={!this.state.zoneSelected} size={'sm'} onClick={async () => {
										if (this.state.re_zone) {
											this.setState({re_zone: null, addZone: false, coords: []})
										} else {
											this.setState({re_zone: this.state.zoneId, addZone: true, coords: []})
										}
									}}>{this.state.re_zone ? 'Cancel Re-Draw' : 'Re-Draw Zone'}</Button>
								</div>}

								{this.props.showButtons && <div className={'col-1 text-right'}>
									<Button color={'info'} size={'sm'} onClick={async () => {
										this.setState({coords: []})
									}}>Clear Coords</Button>
								</div>}

								<div className={this.props.showButtons ? 'col-4' : 'col-9'} style={{display: 'flex', justifyContent: 'flex-end'}}>
									<b>Legend:</b>
									<ul>
										{this.props.showButtons && <li style={{display: 'flex', marginRight: '20px', alignItems: 'center'}}>
											<div style={{
												width: '20px',
												height: '20px',
												backgroundColor: "#0000FF",
												display: 'inline-block',
												marginRight: '5px'
											}}></div>
											Selected / New Coords
										</li>}
										{this.props.showButtons && <li style={{display: 'flex', marginRight: '20px', alignItems: 'center'}}>
											<div style={{
												width: '20px',
												height: '20px',
												backgroundColor: "#808080",
												display: 'inline-block',
												marginRight: '5px'
											}}></div>
											Re-Draw Old Coords
										</li>}
										<li style={{display: 'flex', marginRight: '20px', alignItems: 'center'}}>
											<div style={{
												width: '20px',
												height: '20px',
												backgroundColor: "#FF0000",
												display: 'inline-block',
												marginRight: '5px'
											}}></div>
											Active
										</li>
									</ul>
								</div>
							</div>
							<div className={'row'} style={{alignItems: 'flex-start'}}>
								{this.props.showButtons && (this.state.addZone || this.state.zoneSelected) &&
									<>
										<div className={'col-3'} style={{top: -10}}>
											<FeedbackLocationSelect
												locations={this.state.feedbackLocations}
												selectedRegionPkey={this.state.selectedRegion?.pkey}
												feedbackLocationPkey={object.feedback_location}
												onChange={this.handleFeedbackLocationSelect}
											/>
										</div>
										<div className={'col-3'}>
											<div className="form-group" style={{marginBottom: 0}}>
												<Framework.Elements.TextField
													label="Review Link"
													property={properties.link}
													value={object.link}
													error={object.link_error}
													update={this.handleLinkFieldUpdate}
												/>
												<FormHelperText style={FEEDBACK_FORM_HELPER_TEXT_STYLE}>
													Custom g.page review URL. Required. Updating this does not unlink the feedback location.
												</FormHelperText>
											</div>
										</div>
										<div className={'col-2'}>
											<div className="form-group" style={{marginBottom: 0}}>
												<Framework.Elements.TextField
													label="Internal Name"
													property={properties.name}
													value={object.name}
													error={object.name_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
												<FormHelperText style={FEEDBACK_FORM_HELPER_TEXT_STYLE}>
													Leave blank to use default: {DEFAULT_FEEDBACK_INTERNAL_NAME}
												</FormHelperText>
											</div>
										</div>
										<div className={'col-2'}>
											<div className="form-group" style={{marginBottom: 0}}>
												<Framework.Elements.TextField
													label="Name to Customer"
													property={properties.pretty_name}
													value={object.pretty_name}
													error={object.pretty_name_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
												<FormHelperText style={FEEDBACK_FORM_HELPER_TEXT_STYLE}>
													Required. Shown to the customer in review emails.
												</FormHelperText>
											</div>
										</div>
										<div className={'col-2'}>
											<div className="form-group" style={{marginBottom: 0}}>
												<Framework.Elements.TextField
													label="Ranking"
													property={properties.ranking}
													value={object.ranking}
													error={object.ranking_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
												<FormHelperText style={FEEDBACK_FORM_HELPER_TEXT_STYLE}>
													&nbsp;
												</FormHelperText>
											</div>
										</div>
									</>}
							</div>
						</div>
						<div style={{height: '78vh', width: '100%'}}>
							<GoogleMapReact
								bootstrapURLKeys={getGoogleMapBootstrapURLKeys()}
								defaultCenter={object.defaultCenter}
								defaultZoom={zoom}
								yesIWantToUseGoogleMapApiInternals
								onGoogleApiLoaded={({map, maps}) => this.apiIsLoaded(map, maps)}
								ref={(ref) => {
									this.mapRef = ref;
								}}
								onClick={(obj) => {
									if (!this.props.showButtons) {
										return;
									}
									if (this.state.addZone) {
										const found = this.state.coords.filter((item) => {
											if (item.lat === obj.lat && item.lng === obj.lng) {
												return true;
											}
										})
										if (found.length === 0) {
											this.setState({coords: [...this.state.coords, {lat: obj.lat, lng: obj.lng}]})
										}
									}
								}}
								{...extras}
							>
								{object.coords.length > 0 &&
									<Polygon
										key={'poly'}
										options={{
											paths: this.state.coords,
											strokeColor: "#0000FF",
											strokeOpacity: 0.8,
											map: this.state.map
										}}
									/>
								}

								{object.feedbackZones.map((item) => {
									let color = "#FF0000";
									if (this.state.zoneId === item.pkey) {
										if (this.state.re_zone) {
											color = "#808080"
										} else {
											color = "#0000FF"
										}
									} else if (item.pause) {
										color = "#FFFF00"
									}
									return (
										<>
											<Polygon
												key={'poly_' + item.pkey}
												options={{
													paths: JSON.parse(item.coords),
													strokeColor: color,
													strokeOpacity: 0.8,
													map: this.state.map,
													zIndex: 999
												}}
												onClick={(event) => {
													if (this.state.zoneSelected) {
														this.setState({zoneId: null, zoneSelected: false, selectedCoords: [], selectedZone: null, link: null, feedback_location: null, name: null, pretty_name: null, ranking: null})
													} else if (!this.state.addZone) {
														this.setState({
															zoneId: item.pkey,
															zoneSelected: true,
															selectedCoords: item.coords,
															selectedZone: item,
															link: item.link,
															feedback_location: item.feedback_location || null,
															name: item.name,
															pretty_name: item.pretty_name,
															ranking: item.ranking,
														})
													}
												}}
											/>
										</>
									)
								})}
							</GoogleMapReact>
						</div>
					</div>
				</CardContent>
			</Card>
		)
	}
}
